import * as types from "../constants/actionTypes";


export const headerInitialState = {
    nonLoggedInNotices: null,
    loggedInNotices: null,
    currentUser: null,
    proxyList: null,
    proxyListLoading: false,
    proxyListLoaded: true,
    loginStatus: null,
    primaryUser: null,
    thrive: null,
    eVisit: null,
    error: null,
    forgotPassword: {},
    resetPassword: {},
    changeEmailError: false,
    changeEmailErrorText: null,
    changeEmailSuccessMessage: false,
    userNameResponse: null,
    userNameChangeIsWaiting: false,
    userNameUpdateError: null,
    apiUserNameErrorMessage: null,
    passwordChangeIsWaiting: false,
    passwordUpdateResponse: null,
    passwordUpdateError: null,
    apiPasswordErrorMessage: null,
    normalAppUpdateShow: true
};

export default function headerReducer(state = headerInitialState, action) {
    switch (action.type) {
        case types.SWITCH_USER_SAGA:
            return { ...state, switchingProxyUser: true };
        case types.RESET_USER_VALUE:
            return { ...state, currentUser: null, primaryUser:null };
        case types.SWITCH_USER_REDUCER:
            //const currentUser = state.currentUser;
            const proxyList = state.proxyList;
            const eVisit = proxyList && proxyList.length > action.index ? proxyList[action.index].eVisit : {};
            const user = { ...action.user, eVisit };
            // no more list of avatars so no need to rearrange proxyList
            //if (action.index > 0) {
            //    proxyList.splice(action.index, 1); // remove user from its current location
            //    proxyList.splice(0, 0, user); // re-add user to the beginning
            //    if (currentUser && currentUser.index > 0) {
            //        let index = currentUser.index;
            //        if (action.index > index) {
            //            index++;
            //        }
            //        proxyList.splice(1, 1); // remove current user (now located at the 2nd location)
            //        proxyList.splice(index, 0, currentUser); // re-add user to its original location
            //    }
            //}
            return { ...state, currentUser: user, proxyList: proxyList, eVisit: eVisit, zipnosis: null, switchingProxyUser: false };
        case types.ZIPNOSIS_EVISIT_URL:
            return { ...state, zipnosis: { loading: true, request: action, url: null, errorMessage: null, hasError: false } };
        case types.ZIPNOSIS_EVISIT_URL_SUCCESS:
            return { ...state, zipnosis: { ...state.zipnosis, loading: false, url: action.url, errorMessage: null } };
        case types.ZIPNOSIS_EVISIT_URL_FAILURE:
            return { ...state, zipnosis: { ...state.zipnosis, loading: false, url: null, errorMessage: action.errorMessage, errorMessageName: action.errorMessageName, hasError: true } };
        case types.ZIPNOSIS_EVISIT_CLEAR:
            return { ...state, zipnosis: { loading: false, request: null, url: null, errorMessage: null, hasError: false } };
        case types.USER_AUTHENTICATE_SUCCESS:
            return { ...state, loginStatus: action.type };
        case types.LOGOUT:
        case types.USER_AUTHENTICATE:
        case types.USER_AUTHENTICATE_FAILURE:
            return { ...state, loginStatus: action.type, error: action.errorCode, proxyList: null };
        case types.USER_LOGGED_OUT: return { ...headerInitialState, loginStatus: action.type };

        case types.CHANGE_USERNAME: return { ...state, userNames: action.userNames, userNameChangeIsWaiting: true };
        case types.CHANGE_USERNAME_SUCCESS: return { ...state, userNameResponse: action.userNameUpdateResponse, userNameChangeIsWaiting: false, userNameUpdateError: null, apiUserNameErrorMessage: null };
        case types.CHANGE_USERNAME_FAILURE: return { ...state, userNameUpdateError: action.userNameError, userNameResponse: null, apiUserNameErrorMessage: action.apiErrorMessage, userNameChangeIsWaiting: false };
        case types.CHANGE_USERNAME_CLEAR: return { ...state, userNameUpdateError: null, userNameResponse: null, apiUserNameErrorMessage: null, userNameChangeIsWaiting: false };

        case types.CHANGE_PASSWORD: return { ...state, passwordData: action.passwordData, passwordChangeIsWaiting: true };
        case types.CHANGE_PASSWORD_SUCCESS: return { ...state, passwordUpdateResponse: action.passwordUpdateResponse, passwordChangeIsWaiting: false, passwordUpdateError: null, apiPasswordErrorMessage: null };
        case types.CHANGE_PASSWORD_FAILURE: return { ...state, passwordUpdateError: action.passwordError, passwordUpdateResponse: null, apiPasswordErrorMessage: action.apiErrorMessage, passwordChangeIsWaiting: false };
        case types.CHANGE_PASSWORD_CLEAR: return { ...state, passwordUpdateResponse: null, passwordUpdateError: null, apiPasswordErrorMessage: null, passwordChangeIsWaiting: false };

        case types.FORGOT_PASSWORD_START:
            return { ...state, forgotPassword: { ...state.forgotPassword, inProcess: true, success: null, failure: null } };
        case types.FORGOT_PASSWORD_FAILURE:
            return { ...state, forgotPassword: { ...state.forgotPassword, inProcess: false, failure: action.failure } };
        case types.FORGOT_PASSWORD_SUCCESS:
            return { ...state, forgotPassword: { ...state.forgotPassword, inProcess: false, success: action.success } };
        case types.FORGOT_PASSWORD_CLEAR:
            return { ...state, forgotPassword: { ...state.forgotPassword, inProcess: false, success: null, failure: null } };

        case types.RESET_PASSWORD_START:
            return { ...state, resetPassword: { ...state.resetPassword, inProcess: true, success: null, failure: null } };
        case types.RESET_PASSWORD_FAILURE:
            return { ...state, resetPassword: { ...state.resetPassword, inProcess: false, failure: action.failure } };
        case types.RESET_PASSWORD_SUCCESS:
            return { ...state, resetPassword: { ...state.resetPassword, inProcess: false, success: action.success } };

        case types.FORGOT_USERNAME_START:
            return { ...state, forgotUserNameWaiting: true, forgotUserNameError: false };
        case types.FORGOT_USERNAME_SUCCESS:
            return { ...state, forgotUserNameWaiting: false, forgotUserNameError: false, forgotUserNameSuccessMessage: action.forgotUserNameSuccessMessage, forgotUserNameFailureMessage: null };
        case types.FORGOT_USERNAME_FAILURE:
            return { ...state, forgotUserNameWaiting: false, forgotUserNameError: true, forgotUserNameFailureMessage: action.forgotUserNameFailureMessage, forgotUserNameSuccessMessage: null };
        case types.FORGOT_USERNAME_CLEAR:
            return { ...state, forgotUserNameWaiting: false, forgotUserNameError: null, forgotUserNameFailureMessage: null, forgotUserNameSuccessMessage: null };

        case types.RESET_LOGIN_SETTINGS_DATA:
            return { ...state, passwordUpdateError: false, passwordUpdateResponse: true, apiPasswordErrorMessage: false, userNameUpdateError: false, userNameResponse: true, apiUserNameErrorMessage: false };

        case types.CHANGE_EMAIL_START:
            return { ...state, changeEmailWaiting: true, changeEmailError: false };
        case types.CHANGE_EMAIL_SUCCESS:
            return { ...state, changeEmailWaiting: false, changeEmailError: false, changeEmailSuccessMessage: action.changeEmailSuccessMessage };
        case types.CHANGE_EMAIL_FAILURE:
            return {
                ...state, changeEmailWaiting: false, changeEmailError: action.changeEmailFailureMessage, changeEmailSuccessMessage: false, changeEmailErrorText: action.changeEmailErrorText
            };
        case types.CHANGE_EMAIL_CLEAR_MESSAGE:
            return { ...state, changeEmailError: null, changeEmailSuccessMessage: null, changeEmailErrorText: null };

        case types.ADD_OR_UPDATE_USER_PHONE_NUMBER_START:
            return { ...state, addOrUpdateSuccess: false, IsUpdateEror: false, statusMessage: "Please wait..." };

        case types.ADD_OR_UPDATE_USER_PHONE_NUMBER_SUCCESS:
            return { ...state, addOrUpdateSuccess: true, IsUpdateEror: false, statusMessage: action.addUpdateUserPhoneNumberSuccessText };

        case types.HIDE_NORMAL_APP_UPDATE:
            return { ...state, normalAppUpdateShow: false };

        default: return { ...state };

    }
}